package com.neurobs.ccabserver.administrator.contexts

import com.neurobs.ccab.CCABServer
import com.neurobs.js.ccab.RelativeJSCCABServer
import com.neurobs.react.ContextBase

object ServerContext extends ContextBase[CCABServer] {
	override protected def defaultStateValue(): CCABServer = RelativeJSCCABServer()
}
